import { useState, useCallback } from "react";

export interface IUseFocus {
  isFocused: boolean;
  onFocus: () => void;
  onBlur: () => void;
}

const useFocus = (initialState: boolean = false): IUseFocus => {
  const [isFocused, setIsFocused] = useState<boolean>(initialState);

  const onFocus = useCallback((): void => {
    setIsFocused(true);
  }, []);

  const onBlur = useCallback((): void => {
    setIsFocused(false);
  }, []);

  return {
    isFocused,
    onFocus,
    onBlur,
  };
};

export default useFocus;